import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DYNAMIC_COMPONENT_DATA } from '@principle-theorem/ng-shared';
import { Observable, of } from 'rxjs';
import { IIntegrationActionData } from '../../../../integration-action-data';
import { DentalEyeFeatureService } from '../dentaleye-feature.service';
import { BridgeDeviceSelectorService } from '../../../bridge-device-selector-dialog/bridge-device-selector.service';
import { DENTALEYE_INTEGRATION } from '@principle-theorem/principle-bridge-core';

@Component({
  selector: 'pr-dentaleye-open-patient',
  templateUrl: './dentaleye-open-patient.component.html',
  styleUrl: './dentaleye-open-patient.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DentalEyeOpenPatientComponent {
  isDisabled$: Observable<boolean>;

  constructor(
    @Inject(DYNAMIC_COMPONENT_DATA)
    private _data: IIntegrationActionData,
    private _dentalEye: DentalEyeFeatureService,
    private _bridgeDeviceSelector: BridgeDeviceSelectorService
  ) {
    this.isDisabled$ = of(false);
  }

  async openPatient(): Promise<void> {
    const device = await this._bridgeDeviceSelector.selectDevice(
      DENTALEYE_INTEGRATION
    );
    if (!device) {
      return;
    }

    await this._dentalEye.openPatient(this._data.patient, device.ref);
  }
}
